import { Controller, useFormContext, useWatch } from 'react-hook-form';
import type { ProgramEditorValues } from '@features/programs';
import { InfoIcon } from '@shared/assets/index.ts';
import { useAppDispatch } from '@shared/hooks/index.ts';
import { Card, Toggle } from '@shared/ui';
import { openNotifyModal } from '@src/library/redux/modal/index.ts';
import * as st from './styles.module.scss';

export const EditorPeriodicity = (): JSX.Element => {
  /**
   * TODO:  Разобраться с условиями при которых disabled
   */
  const dispatch = useAppDispatch();
  const { control } = useFormContext<ProgramEditorValues>();
  const isEnabledPeriodicity = useWatch({ name: 'periodicity', control });

  const onIconClick = () => {
    dispatch(
      openNotifyModal({
        title: 'Периодичность',
        text: `Функция "Периодичность" позволяет пользователям назначить индивидуальный список видео для каждого из семи дней недели.`,
        confirmText: 'Понятно',
        buttonClassName: st.notifyButton,
        fullWidthText: true,
      })
    );
  };

  return (
    <fieldset>
      <div className={st.header}>
        <h3>Периодичность</h3>
        <InfoIcon className={st.icon} onClick={onIconClick} />
      </div>
      <Card className={st.periodicity}>
        <div className={st.wrapper}>
          <span>{isEnabledPeriodicity ? 'Включена' : 'Отключена'}</span>
          <Controller
            name="periodicity"
            control={control}
            render={({ field: { value, onChange } }) => (
              <Toggle value={value} onToggle={(value) => onChange(value)} />
            )}
          />
        </div>
      </Card>
    </fieldset>
  );
};
